// Cloud provider catalog — extracted from CloudConfig.jsx during P2 refactor.
// Pure data; no React imports needed.

export const providerConfig = {
  aws: {
    name: 'Amazon Web Services',
    logo: '🟠',
    color: 'orange',
    bgColor: 'bg-orange-500/10',
    textColor: 'text-orange-500',
    borderColor: 'border-orange-500',
    accountLabel: 'AWS Account',
    accountIdLabel: 'Account ID',
    credentialFields: [
      { key: 'access_key_id', label: 'Access Key ID', type: 'text', placeholder: 'AKIAIOSFODNN7EXAMPLE' },
      { key: 'secret_access_key', label: 'Secret Access Key', type: 'password', placeholder: '••••••••••••••••' },
      { key: 'region', label: 'Default Region', type: 'select', options: ['us-east-1', 'us-west-2', 'eu-west-1', 'ap-southeast-1'] }
    ]
  },
  azure: {
    name: 'Microsoft Azure',
    logo: '🔵',
    color: 'blue',
    bgColor: 'bg-blue-500/10',
    textColor: 'text-blue-500',
    borderColor: 'border-blue-500',
    accountLabel: 'Azure Subscription',
    accountIdLabel: 'Subscription ID',
    credentialFields: [
      { key: 'tenant_id', label: 'Tenant ID', type: 'text', placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'client_id', label: 'Client ID (App ID)', type: 'text', placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
      { key: 'client_secret', label: 'Client Secret', type: 'password', placeholder: '••••••••••••••••' },
      { key: 'subscription_id', label: 'Subscription ID', type: 'text', placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' }
    ]
  },
  gcp: {
    name: 'Google Cloud Platform',
    logo: '🔴',
    color: 'red',
    bgColor: 'bg-red-500/10',
    textColor: 'text-red-400',
    borderColor: 'border-red-400',
    accountLabel: 'GCP Project',
    accountIdLabel: 'Project ID',
    credentialFields: [
      { key: 'project_id', label: 'Project ID', type: 'text', placeholder: 'my-project-123456' },
      { key: 'service_account_json', label: 'Service Account JSON', type: 'textarea', placeholder: 'Paste service account JSON key...' }
    ]
  }
};
